export const social = {
  facebook: {
    link: 'https://www.facebook.com/villatravellers',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/facebook.webp`,
    alt: 'Facebook',
  },
  x: {
    link: 'https://www.twitter.com/villatravellers',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/x.webp`,
    alt: 'X',
  },
  instagram: {
    link: 'https://www.instagram.com/villatravellers',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/instagram.webp`,
    alt: 'Instagram',
  },
  youtube: {
    link: 'https://www.youtube.com/channel/UCv4EiCmH8bDPfF7zSdMtVmQ',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/youtube.webp`,
    alt: 'Youtube',
  },
  spotify: {
    link: 'https://open.spotify.com/user/5j42u2y4025fchvqr8n7dprtl',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/spotify.webp`,
    alt: 'Spotify',
  },
  linkedin: {
    link: 'https://www.linkedin.com/company/villatravellers',
    imgPath: `${process.env.NEXT_PUBLIC_S3_URI}/assets/images/webp/social/linkedin.webp`,
    alt: 'Linkedin',
  },
};
